module.exports = __webpack_public_path__ + "static/pic01@5x-089b5d0abe8dfab0e0a2e4ecc83585b5.jpg";